export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityWater128.1eb2541a.svg";